import React from 'react'
import { getJti } from '../../index'

export const getSubmitModalContent = (type, url) => {
  return {
    className: 'success-modal',
    width: 720,
    content: (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            style={{ width: 36, height: 36 }}
            src="//qnm.hunliji.com/o_1cuj5milq1ni4jsep3c1l4j1d7o9.png "
          />
          <span style={{ fontSize: 32, color: '#333', marginLeft: 15 }}>
            提交成功
          </span>
        </div>

        <div style={{ marginTop: 40, fontSize: 16, color: '#101010' }}>
          <p>
            1.
            工作日提交：当日17：00前提交的会在当日完成审核，17：00后提交的将在下一个工作日完成审核
          </p>
          <p style={{ marginTop: 20 }}>
            2. 非工作日提交：将在下一个工作日完成审核
          </p>
          <p style={{ marginTop: 20 }}>
            注：扫描下方二维码绑定微信，可在微信中及时获取审核动态
          </p>

          <div className="text-center" style={{ marginTop: 40 }}>
            <img
              src={
                url
                  ? url
                  : `/p/wedding/index.php/${type}/APIMerchant/qrcode?jti=${getJti()}&x=${Math.random()}`
              }
              style={{ width: 160, height: 160 }}
            />
            <p className="text-center">微信扫码，及时获取审核动态</p>
          </div>
        </div>
      </>
    ),
    okText: '返回首页'
  }
}
